<template>
    <v-app class="pa-0 grey lighten-5" style="min-height: 100vh; margin: 0 auto; display: flex; flex-direction: column;">
        <v-overlay :value="dLoading" z-index="10">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row 
            v-if="dMessage.show" 
            justify="center" 
            align="start" 
            class="ma-0" 
            :style="{ 'background-color': dMessage.color, 'height': '100vh', 'width': '100%' }"
        >
            <v-col cols="12" class="pa-0 d-flex flex-column align-center justify-center">
                <div class="text-center w-100" style="width: 100%;">                    
                    <div class="d-flex justify-center mb-4">
                        <v-icon size="200" dark>{{ dMessage.icon }}</v-icon>
                    </div>                    
                    <h3 class="text-h2 mb-2" style="font-size: 5vh; opacity:.9; color:white; line-height: 1.2;">
                        {{ dMessage.title }}
                    </h3>
                    <h4 class="text-h4 mb-4" style="font-size: 3vh; opacity:.8; color:rgba(255,255,255,0.7)">
                        {{ dMessage.body }}
                    </h4>
                    <ul v-if="dMsgError && dMsgError.length != 0" class="pa-0" style="list-style: none; font-size: 2vh; color: white;">
                        <li v-for="(item,index) in dMsgError" :key="index" class="mb-1">
                            {{item.message}}
                        </li>
                    </ul>
                </div>
            </v-col>
        </v-row>
        <div v-else-if="dMatMatriculaLast">
            <div elevation="4" style="padding:15px" class="bsp_header" dark>
                <v-row no-gutters class="mb-2">
                    <v-col cols="3" class="text-right pr-2">
                        <span class="label-titulo">Carrera:</span>
                    </v-col>
                    <v-col cols="9">{{dMatMatriculaLast.matseccion.matperiodo.priservicio.Descripcion}}</v-col>
                </v-row>
                <v-row no-gutters class="mb-2">
                    <v-col cols="3" class="text-right pr-2">
                        <span class="label-titulo">Periodo:</span>
                    </v-col>
                    <v-col cols="9">{{dMatMatriculaLast.matseccion.matperiodo.Anio}}-{{dMatMatriculaLast.matseccion.matperiodo.Periodo}}</v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="3" class="text-right pr-2">
                        <span class="label-titulo">Sección:</span>
                    </v-col>
                    <v-col cols="9">{{dMatMatriculaLast.matseccion.matperiodo.Nivel}} - {{dMatMatriculaLast.matseccion.Seccion}}</v-col>
                </v-row>
            </div>
            <div class="px-4 mt-6">
                <v-list three-line>
                    <v-list-item-group>
                        <v-row v-for="item in dCceEvaluacionDocente" :key="item.IdEvaluacionDocente"  justify="center">
                            <v-col cols="12" sm="12" md="8" lg="6" align="center" class="pa-0">
                                <v-list-item
                                    @click.prevent="fuSelected(item)"
                                    :style="{ 
                                        borderColor: (item.Estado === 'EVALUADO' ? 'green' : '#5c7cbe') + ' !important',
                                        borderRadius: '30px !important', 
                                        borderWidth: '2px !important',
                                        borderStyle: 'solid',
                                        overflow: 'hidden',
                                        margin: '5px !important',
                                        opacity: item.Estado === 'EVALUADO' ? '0.85' : '1'
                                    }"
                                >
                                    <v-list-item-avatar size="80" class="ma-1">
                                        <v-hover v-slot="{ hover }">
                                            <v-img
                                                v-if="!item.error"
                                                :src="fuFoto(item.DNI)" 
                                                @error="$set(item, 'error', true)"
                                                :style="{ 
                                                    border: '4px solid ' + (item.Estado === 'EVALUADO' ? '#4CAF50' : '#2196F3'),
                                                    transition: 'transform 0.3s ease-in-out',
                                                    transform: hover ? 'scale(2.0)' : 'scale(1)',
                                                    zIndex: hover ? 10 : 1
                                                }"
                                            ></v-img>
                                            <v-icon 
                                                v-else 
                                                :style="{ color: item.Estado === 'EVALUADO' ? '#4CAF50' : '#2196F3' }" 
                                                size="60"
                                            >
                                                face
                                            </v-icon>
                                        </v-hover>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="text-left">
                                        <v-list-item-title 
                                            class="text-uppercase" 
                                            :style="{ 
                                                fontWeight: '900 !important',
                                                color: item.Estado === 'EVALUADO' ? '#4CAF50' : '#2196F3'
                                            }"
                                        >
                                            {{ item.Personal }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="grey--text text--darken-3 font-weight-medium mt-1">
                                            {{ item.Descripcion }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon v-if="item.Estado=='EVALUADO'" color="success" x-large>check_circle</v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-list-item-group>
                </v-list>
            </div>
        </div>
        <v-dialog
            v-model="dModal.dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-form ref="refMain" lazy-validation>
                <v-card>
                    <v-list v-if="dCceEvaluacionDocenteSelect" elevation="4" three-line color="blue" dark>
                        <v-list-item-group>
                            <v-list-item>
                                <v-list-item-avatar size="80" class="ma-1">
                                    <v-hover v-slot="{ hover }">
                                        <v-img
                                            v-if="!dCceEvaluacionDocenteSelect.error"
                                            :src="fuFoto(dCceEvaluacionDocenteSelect.DNI)" 
                                            @error="$set(dCceEvaluacionDocenteSelect, 'error', true)"
                                            :style="{ 
                                                        transition: 'transform 0.3s ease-in-out',
                                                        transform: hover ? 'scale(2.0)' : 'scale(1)',
                                                        zIndex: hover ? 10 : 1
                                                    }"
                                        ></v-img>
                                        <v-icon v-else size="60">face</v-icon>
                                    </v-hover>
                                </v-list-item-avatar>
                                <v-list-item-content class="text-left">
                                    <v-list-item-title class="text-uppercase">
                                        {{ dCceEvaluacionDocenteSelect.Personal }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="font-weight-medium mt-1">
                                        {{ dCceEvaluacionDocenteSelect.Descripcion }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon @click="dModal.dialog=false" color="white" x-large><v-icon>close</v-icon></v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    <v-card v-for="(item2, index) in dPreguntasSelected" :key="item2.IdPregunta" class="mx-3 portrait">
                        <v-card-text style="background:#E3F2FD">
                            <span class="doc-card-title py-2"> {{index+1}} </span>
                            <span style="font-weight: 900 !important;">{{item2.Pregunta}}</span>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="py-0">
                            <v-radio-group v-model="item2.Respuesta" row :rules="[v => !!v || 'Seleccione una alternativa']" class="ma-0 pa-0 radio-grande">
                                <v-radio v-for="item3 in item2.alternativas" :key="item3.IdAlternativa" :label="item3.Descripcion" :value="item3.IdAlternativa" color="primary" class="mr-6 mb-2 mt-2"></v-radio>
                            </v-radio-group>
                        </v-card-actions>
                    </v-card>
                    <v-textarea
                        v-model="dObservacion"
                        outlined
                        name="input-7-4"
                        label="Escribe tus sugerencias para mejorar el servicio del docente"
                        value=""
                        class="ma-4 mx-1 mb-0"
                        rows="1"
                        auto-grow
                        counter
                        @blur="fuCleanRepeatedChars"
                        :rules="[ v => !!v || 'El campo es requerido', v => (v.length >= 20) || 'El campo debe ser mayor de 19 caracteres.', v => (v.length <= 150) || 'El campo debe ser menor de 150 caracteres.']" :maxlength="150" autocomplete="off"
                    ></v-textarea>
                    <v-btn 
                        @click.prevent="fuSave(dCceEvaluacionDocenteSelect.IdEvaluacionDocente)"
                        :loading="dModal.loading"
                        color="primary" block><v-icon>save</v-icon>Guardar
                    </v-btn>
                </v-card>
            </v-form>
        </v-dialog>
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {fuFoto} from '@/helpers/index.js';

export default {
    name: 'CceEvaluacionDocente',
    mounted(){
        this.fuLoad();
    },
    data: () => ({
        dLoading : true,
        dMatMatriculaLast: null,
        dCceEvaluacionDocenteSelect: null,
        dCceEvaluacionDocente: [],
        dCceCceencuestaFecha: [],
        dPreguntasSelected: [],
        dMessage: {
            show: false,
            title: "",
            body: "",
            icon: "",
            color: "white",//#EF9A9A  b3e5fc
        },
        dMsgError: [],
        dObservacion: "",
        dModal: {
            dialog: false,
            loading: false,
        },
    }),
    methods: {
        fuFoto,
        async fuLoad() {
            this.dLoading = true;
            this.dMsgError = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query consulta($IdAlumno: ID!, $IdAlumno2: Int!){
                        matmatriculaLast(IdAlumno:$IdAlumno){
                            IdMatricula
                            matseccion{
                                Seccion
                                matperiodo{
                                    Anio
                                    Periodo
                                    Nivel
                                    priservicio{
                                        Descripcion
                                    }
                                }
                            }
                        }
                        cceevaluaciondocenteXIdAlumno(IdAlumno:$IdAlumno2){
                            IdEvaluacionDocente
                            Estado
                            Personal
                            DNI
                            Descripcion
                        }
                        cceencuestafechaByAspecto(Aspecto:"Encuesta Docente"){
                            IdEncuestasFechas
                            cceencuestadetalles{
                                id
                                ccecuestionario{
                                    IdPregunta
                                    Pregunta
                                }
                                ccealternativa{
                                    IdAlternativa
                                    Descripcion
                                }			
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: this.$route.params.pIdAlumno,
                        IdAlumno2: this.$route.params.pIdAlumno,
                    }
                })
                this.dMatMatriculaLast = response.data.matmatriculaLast[0];
                this.dCceEvaluacionDocente = response.data.cceevaluaciondocenteXIdAlumno.map(item => ({
                    ...item,
                    error: false
                }));                

                const data = response.data.cceencuestafechaByAspecto;                               
                if(data.length>0){
                    this.dCceCceencuestaFecha = data[0].cceencuestadetalles.reduce((acc, curr) => {
                        const idPregunta = curr.ccecuestionario.IdPregunta;
                        let preguntaExistente = acc.find(p => p.IdPregunta === idPregunta);
                        if (!preguntaExistente) {
                            preguntaExistente = {
                                IdPregunta: idPregunta,
                                Pregunta: curr.ccecuestionario.Pregunta,
                                Respuesta: null, // Campo que almacenará el ID de la alternativa seleccionada
                                alternativas: []
                            };
                            acc.push(preguntaExistente);
                        }
                        preguntaExistente.alternativas.push({
                            IdAlternativa: curr.ccealternativa.IdAlternativa,
                            Descripcion: curr.ccealternativa.Descripcion
                        });
                        return acc;
                    }, []);
                }

                if(this.dCceEvaluacionDocente.every(item => item.Estado === 'EVALUADO'))
                    window.parent.postMessage("EVALUADO", "*");

                if(data.length<=0)
                    this.dMsgError.push({ error:1, message: "No existe encuesta activa.", data:""});

                if(this.dCceEvaluacionDocente.length<=0)
                    this.dMsgError.push({ error:1, message: "No le corresponde la encuesta.", data:""});

                if(this.dMsgError.length>0){
                    this.dMessage = { show: true, title: "No encuesta", body: "", icon: "cancel", color: "#EF9A9A"};
                    window.parent.postMessage("EVALUADO", "*");
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuSave (p_IdEvaluacionDocente) {
            if(!this.$refs.refMain.validate()){
                console.log("Formulario no válido - faltan completar respuestas.");
            } else {
                this.fuRegistrarRespuestas(p_IdEvaluacionDocente);
            }
        },
        fuSelected(vItem){
            if(vItem.Estado != 'EVALUADO'){
                this.dCceEvaluacionDocenteSelect = vItem;            
                this.dModal.dialog = true;
                this.dObservacion = "";
                this.dPreguntasSelected = [];
                this.dPreguntasSelected = JSON.parse(JSON.stringify(this.dCceCceencuestaFecha));
            }
        },
        async fuRegistrarRespuestas(p_IdEvaluacionDocente){
            try {
                this.dModal.loading = true;
                const vRespuestas = this.dPreguntasSelected.map(p => ({
                    IdPregunta: p.IdPregunta,
                    IdAlternativa: p.Respuesta
                }));

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation cceevaluaciondocenteRegistrarRespuestas($IdEvaluacionDocente: Int!, $Observacion: String, $input: [CceCalificacionCreateInput!]!){
                        cceevaluaciondocenteRegistrarRespuestas(IdEvaluacionDocente: $IdEvaluacionDocente, Observacion: $Observacion, input: $input){
                            IdEvaluacionDocente
                        }
                    }`,
                    variables: {
                        IdEvaluacionDocente: p_IdEvaluacionDocente,
                        Observacion: this.dObservacion,
                        input: vRespuestas
                    }
                });
                if(response.data.cceevaluaciondocenteRegistrarRespuestas){
                    this.fuLoad();
                    this.dModal.dialog = false;
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: response.data.matmatriculaRetirar.message})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dModal.loading = false;
            }
        },
        fuCleanRepeatedChars() {
            if (this.dObservacion) {
                let text = this.dObservacion.trim();
                const isAllSameChar = /^(.)\1*$/.test(text);
                
                if (isAllSameChar && text.length > 0) {
                    this.dObservacion = text.charAt(0);
                } else {
                    this.dObservacion = text;
                }
            }
        }
    }
}
</script>
<style scoped>
    .bsp_header {
        background: linear-gradient(130deg, transparent 0% 87%, rgba(255, 255, 255, .6) 87.1% 100%),
                    linear-gradient(130deg, transparent 0% 75%, rgba(255, 255, 255, .4) 75.1% 100%),
                    linear-gradient(90deg, transparent 0% 35%, rgba(255, 255, 255, .3) 65.1% 100%),
                    linear-gradient(130deg, transparent 0% 60%, rgba(255, 255, 255, .2) 60.1% 100%),
                    linear-gradient(90deg, #3498db 0%, #2980b9 100%); /* Color base reemplazando var(--headerPrimary) */
        color: white;
    }
    .doc-card-title {
        margin-left: -24px;
        margin-right: 10px;
        padding: 2px 10px 2px 15px;
        background: #42A5F5;
        color: #ffffff;
        position: relative;
        border-radius: 3px 5px 5px 0;
        width: 100;
    }
    /* Estilos para hacer más grande el radio button */
    .radio-grande ::v-deep .v-icon {
        font-size: 32px !important; /* Aumenta el círculo del radio */
    }
    .radio-grande ::v-deep label {
        font-size: 1.1rem !important; /* Aumenta el texto de la respuesta */
        font-weight: 600;
        color: #333 !important;
        padding-left: 8px;
    }
    /* Espaciado táctil para los radios */
    .radio-grande ::v-deep .v-radio {
        margin-right: 24px !important;
    }
    .label-titulo {
        color: black !important;
        font-size: 1rem !important; /* Ajusta este valor (1.5rem, 20px, etc.) */
        font-weight: 900 !important;  /* Máximo grosor */
        display: inline-block;
    }
</style>